<h3-scene-canvas
  [viewRegionNames]="viewRegionNames"
  [size]="size$ | async"
  [useTransparentBackground]="false"
></h3-scene-canvas>
